import React from 'react';
import { PokemonCard } from '../../types/pokemon';
import { SUPABASE_IMAGE_BASE_URL } from '../../lib/constants';

interface UserCollectionCardItemProps {
  card: PokemonCard;
  quantity: number;
  onClick?: () => void;
}

export function UserCollectionCardItem({ 
  card, 
  quantity = 0, 
  onClick
}: UserCollectionCardItemProps) {
  const cardName = card.card_fr;
  const imageUrl = card.image ? `${SUPABASE_IMAGE_BASE_URL}${card.image}` : null;

  return (
    <div 
      className="group relative bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
    >
      <div 
        onClick={onClick} 
        className="block cursor-pointer"
      >
        {imageUrl && (
          <div className="aspect-[3/4] overflow-hidden py-4">
            <img
              src={imageUrl}
              alt={cardName || 'Carte Pokémon'}
              className={`w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-300 ${
                quantity === 0 ? 'grayscale' : ''
              }`}
            />
          </div>
        )}
        <div className="p-4">
          <h3 className="text-lg font-semibold text-gray-900 truncate">
            {cardName}
          </h3>
          <div className="mt-1 flex items-center justify-between">
            <span className="text-sm text-gray-500 truncate">{card.set}</span>
            <span className="px-2 py-1 text-xs font-medium bg-indigo-100 text-indigo-800 rounded-full">
              {card.rarity}
            </span>
          </div>
        </div>
      </div>
      
      {/* Affichage de la quantité sans boutons + et - */}
      <div className="absolute top-2 right-2 flex items-center gap-1 bg-white/90 backdrop-blur-sm rounded-lg px-2 py-1 shadow-lg">
        <span className="text-sm font-medium text-gray-700">
          x{quantity}
        </span>
      </div>
    </div>
  );
} 